import { Show } from "solid-js";
import clsx from "~/util/html/style";
import { formatPhoneNumber } from "~/util/format";

type HeaderLocation = {
  name: string;
  address: string | null;
  // When present, the address renders as a link (online scheduling); otherwise plain text.
  addressLink?: string | null;
  phone: string | null;
  logoUrl: string | null;
};

// Branded header bar for public forms: practice name, address, phone, and logo. `class` carries the
// surrounding chrome (border / background / padding) so each form keeps its own spacing.
export function PublicFormHeader(props: { location: HeaderLocation; class?: string }) {
  return (
    <div class={clsx("flex items-center justify-between gap-4", props.class)}>
      <div class="min-w-0">
        <h1 class="truncate text-lg font-semibold text-typography-primary">
          {props.location.name}
        </h1>
        <div class="flex flex-wrap gap-x-3 gap-y-0.5 text-sm text-typography-secondary">
          <Show when={props.location.address}>
            {(addr) => (
              <Show when={props.location.addressLink} fallback={<span>{addr()}</span>}>
                {(link) => (
                  <a
                    href={link()}
                    target="_blank"
                    rel="noopener noreferrer"
                    class="hover:text-typography-primary hover:underline"
                  >
                    {addr()}
                  </a>
                )}
              </Show>
            )}
          </Show>
          <Show when={props.location.phone}>
            {(phone) => (
              <a href={`tel:${phone()}`} class="hover:text-typography-primary hover:underline">
                {formatPhoneNumber(phone())}
              </a>
            )}
          </Show>
        </div>
      </div>
      <Show when={props.location.logoUrl}>
        {(url) => (
          <img
            src={url()}
            alt={props.location.name}
            class="h-14 w-auto shrink-0 rounded-xl object-contain"
          />
        )}
      </Show>
    </div>
  );
}
